export const ALL_CONFIRM_SALES_ORDER_REQUEST = "ALL_CONFIRM_SALES_ORDER_REQUEST";
export const ALL_CONFIRM_SALES_ORDER_SUCCESS = "ALL_CONFIRM_SALES_ORDER_SUCCESS";
export const ALL_CONFIRM_SALES_ORDER_FAIL = "ALL_CONFIRM_SALES_ORDER_FAIL";